// useFieldModalController.js

import { useCallback, useState } from 'react';

export default function useFieldModalController({
  canEdit = true,
  canAddFields = canEdit,
  canManageFields = canEdit,
} = {}) {
  const [fieldModalOpen, setFieldModalOpen] = useState(false);
  const [fieldInsertIndex, setFieldInsertIndex] = useState(null);
  const [fieldEditingField, setFieldEditingField] = useState(null);

  const handleFieldModalOpen = useCallback((open) => {
    setFieldModalOpen(open);
    if (!open) {
      setFieldInsertIndex(null);
      setFieldEditingField(null);
    }
  }, []);

  const handleAddFieldClick = useCallback((index) => {
    if (!canAddFields) return;
    setFieldInsertIndex(index);
    setFieldEditingField(null);
    setFieldModalOpen(true);
  }, [canAddFields]);

  const handleSettingsClick = useCallback((field) => {
    if (!field || !canManageFields) return;
    setFieldEditingField(field);
    setFieldInsertIndex(null);
    setFieldModalOpen(true);
  }, [canManageFields]);

  const resetFieldModalState = useCallback(() => {
    setFieldModalOpen(false);
    setFieldInsertIndex(null);
    setFieldEditingField(null);
  }, []);

  return {
    fieldModalOpen,
    fieldInsertIndex,
    fieldEditingField,
    handleFieldModalOpen,
    handleAddFieldClick,
    handleSettingsClick,
    resetFieldModalState,
  };
}
